<template>

    <div id="layout-legal" class="layout">
        <v-the-cookie-banner />
        <transition name="modal">
            <v-modal-cookie-preferences v-if="modal === 'cookie-preferences'" />
        </transition>
        <header class="legal-header">
            <router-link :to="{ name: 'home' }" class="logo">
                <img src="/img/mgr-logo.svg" :title="$brand" height="40" width="auto" />
            </router-link>
            <v-dropdown
                :items="menuItems"
                :label="menuLabel"
                :selected="activeKey"
                menu-position="br"
                @change="selectItem" />
        </header>
        <div class="container pb-30">
            <div class="row justify-content-center">
                <div class="legal-layout">
                    <div class="legal-sidebar-wrap">
                        <v-sidebar>
                            <router-link :to="{ name: 'home' }" class="sidebar-header">
                                <img src="/img/mgr-logo.svg" :title="$brand" height="40" width="auto" />
                            </router-link>
                            <v-sidebar-item
                                v-for="item in sidebarItems"
                                :key="item.key"
                                :active="activeKey === item.key"
                                :icon="item.icon"
                                :label="item.label"
                                :to="item.to" />
                        </v-sidebar>
                    </div>
                    <div class="legal-main">
                        <div class="legal-content">
                            <transition name="fade" mode="out-in">
                                <router-view></router-view>
                            </transition>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .legal-layout {
        display: flex;
        max-width: map-get($grid-breakpoints, 'xl');
        width: 100%;
    }

    .legal-main {
        display: flex;
        flex: 1;
        flex-direction: column;
        min-width: 0;
    }

    .legal-header {
        display: none;
    }

    .sidebar-header {
        align-items: center;
        border-bottom: 1px solid $color-rule;
        display: flex;
        flex-shrink: 0;
        justify-content: center;
        margin: -10px -10px 10px -10px;
        padding: 20px 10px;
        text-decoration: none;
    }

    .legal-content {
        flex: 1;
        min-width: 0;
        overflow-y: auto;
        padding: 30px;
    }

    #layout-legal .container {
        padding-top: 30px;
    }

    @media (max-width: map-get($grid-breakpoints, 'md')) {
        .legal-sidebar-wrap {
            display: none;
        }

        .legal-header {
            align-items: center;
            background: $color-white;
            box-shadow: 0 1px 2px rgba(0,0,0,0.2);
            display: flex;
            height: 60px;
            justify-content: space-between;
            left: 0;
            padding: 0 15px;
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 2;
            .logo {
                align-items: center;
                text-decoration: none;
                transition: opacity .3s;
                &:hover {
                    opacity: 0.7;
                }
            }
        }

        #layout-legal .container {
            padding-top: 90px;
        }

        .legal-content {
            padding: 0;
        }
    }

</style>

<script>

import Sidebar from '@cmp/Sidebar';
import SidebarItem from '@cmp/SidebarItem';
import TheCookieBanner from '@cmp/TheCookieBanner';
import { pages } from '@content/prerender/pages';
import ModalCookiePreferences from '@modals/ModalCookiePreferences';
import LegalPolicies from '@utils/LegalPolicies';

export default {

    components: {
        'v-modal-cookie-preferences': ModalCookiePreferences,
        'v-sidebar': Sidebar,
        'v-sidebar-item': SidebarItem,
        'v-the-cookie-banner': TheCookieBanner,
    },

    beforeCreate() {
        document.documentElement.classList.remove('dark-mode');
    },

    computed: {

        activeKey() {
            if (this.isDocument) {
                return this.$route.meta.document;
            }
            return (this.$route.name || '').slice('policies-'.length);
        },

        isDocument() {
            return !!this.$route.meta.document;
        },

        menuItems() {
            return this.sidebarItems.map((item) => ({
                icon: `fas ${item.icon}`,
                key: item.key,
                value: item.label,
            }));
        },

        menuLabel() {
            if (!this.isDocument) {
                return this.$t('labels.policies');
            }
            const item = this.sidebarItems.find((item) => item.key === this.activeKey);
            return item ? item.label : '';
        },

        modal() {
            return this.$store.getters.modal;
        },

        sidebarItems() {
            if (this.isDocument) {
                return pages.map((page) => ({
                    icon: page.icon,
                    key: page.name,
                    label: page.label,
                    to: { name: page.name },
                }));
            }
            return LegalPolicies.map((policy) => ({
                icon: policy.icon,
                key: policy.key,
                label: this.$t(policy.label),
                to: { name: `policies-${policy.key}` },
            }));
        },

    },

    methods: {

        selectItem(item) {
            const match = this.sidebarItems.find((entry) => entry.key === item.key);
            if (match) {
                this.$router.push(match.to);
            }
        },

    },

}

</script>
